declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
}

export const descargarArchivo = (blob: Blob, nombreArchivo: string) => {
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, nombreArchivo);
    } else {
        const link = document.createElement("a");
        if (link.download != null) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", nombreArchivo);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
